import { Observable } from 'rxjs';
import { Contacto } from '../interfaces/contacto';
import { GeneralResponse } from '../interfaces/general-response';


export abstract class ContactoService {


    abstract getContactoAgendamiento(): Observable<Contacto> ;

    abstract postContactoAgendamiento(datosContacto: Contacto): Observable<GeneralResponse<any>>;

}
